import axios from 'axios';

import AppSettings from '../../../constants';

const baseAxiosInstance = axios.create({
    baseURL: AppSettings.routes.api,
    paramsSerializer: { indexes: null },
});

export { baseAxiosInstance };
